import { render, staticRenderFns } from "./checkAdmissions.vue?vue&type=template&id=6c594b1b&scoped=true"
import script from "./checkAdmissions.vue?vue&type=script&lang=js"
export * from "./checkAdmissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c594b1b",
  null
  
)

export default component.exports